import { useContext, useEffect, useRef, useState } from 'react'

import CookiesContext from 'contexts/CookiesContext'

import * as service from 'service'

const useCookies = (
  cookieRoute = async () => null,
  params = {},
  observable = [],
) => {
  const context = useContext(CookiesContext)

  if (context === undefined) {
    throw new Error('useCookies must be used within a CookiesContext.Provider')
  }

  const { setLoading, authenticating } = context
  const [response, setResponse] = useState({})
  const [error, setError] = useState(null)
  const [refreshCounter, setRefreshCounter] = useState(0)

  // Evita erros nos quais o componente é desmontado antes da requisição ser concluída e o estado é atualizado
  const isMounted = useRef(true)

  const loadData = async () => {
    if (!service.cookies.auth.isAuthenticated()) return

    try {
      setLoading(true)
      if (isMounted.current) setError(null)

      const response = await cookieRoute(params)

      if (isMounted.current) setResponse(response)
    } catch (requestError) {
      if (isMounted.current) setError(requestError)
    } finally {
      // Sem este finally, qualquer rejeição (firewall, rede, 5xx) deixava o
      // LoadingFeedback preso na tela para sempre.
      setLoading(false)
    }
  }

  useEffect(() => {
    isMounted.current = true

    if (!authenticating) loadData()

    return () => {
      isMounted.current = false
    }
    //eslint-disable-next-line
  }, [refreshCounter, authenticating, ...observable])

  const refresh = () => setRefreshCounter((prev) => prev + 1)

  return {
    isLoading: context.loading,
    response,
    error,
    refresh,
  }
}

export default useCookies
